import React from 'react';

import { Trans, useTranslation } from 'react-i18next';

export function WhyCheckmateSection() {
  const { t } = useTranslation('home');

  const FEATURES_DATA = [
    {
      id: 1,
      titleKey: 'home:whyCheckmate.features.licensed.title',
      badge: t('whyCheckmate.features.licensed.badge'),
      badgeColor: 'text-[#FF2D2E]',
      icon: <img src="/images/home/certificated-success.svg" alt="certified" className="h-[24px] w-[24px]" />,
      width: 'w-full md:w-[470px]',
    },
    {
      id: 2,
      titleKey: 'home:whyCheckmate.features.verified.title',
      badge: t('whyCheckmate.features.verified.badge'),
      badgeColor: 'text-[#FF2D2E]',
      icon: <img src="/images/home/certificated-success.svg" alt="certified" className="h-[24px] w-[24px]" />,
      width: 'w-full md:w-[470px]',
    },
    {
      id: 3,
      titleKey: 'home:whyCheckmate.features.satisfaction.title',
      badge: t('whyCheckmate.features.satisfaction.badge'),
      badgeColor: 'text-[#FF2D2E]',
      icon: null,
      width: 'w-full md:w-[304px]',
    },
    {
      id: 4,
      titleKey: 'home:whyCheckmate.features.pricing.title',
      badge: t('whyCheckmate.features.pricing.badge'),
      badgeColor: 'text-[#FF2D2E]',
      icon: null,
      width: 'w-full md:w-[304px]',
    },
    {
      id: 5,
      titleKey: 'home:whyCheckmate.features.allInOne.title',
      badge: t('whyCheckmate.features.allInOne.badge'),
      badgeColor: 'text-[#FF2D2E]',
      icon: null,
      width: 'w-full md:w-[304px]',
    },
  ] as const;

  return (
    <section className="hidden w-full flex-col items-center gap-[10px] bg-[#251F1F] px-5 pb-16 pt-12 md:flex md:px-[270px] md:pb-[140px] md:pt-[100px]">
      <div className="flex w-full flex-col items-center gap-8 md:w-[968px] md:gap-[50px]">
        {/* Header */}
        <div className="flex w-full max-w-[506px] flex-col items-center gap-4 md:gap-[24px]">
          <div className="flex h-[68px] w-[68px] items-center justify-center">
            <img src="/images/illusts/my_page_icon.png" alt="checkmate" className="h-[68px] w-[68px]" />
          </div>
          <div className="flex w-full flex-col items-center gap-[4px]">
            <h2 className="text-center text-2xl font-bold leading-[1.3] tracking-[-0.022em] text-white md:text-[28px]">
              {t('whyCheckmate.title')}
            </h2>
          </div>
        </div>

        {/* Features Grid */}
        <div className="flex w-full flex-col gap-4 md:gap-[28px]">
          {/* First Row - 2 large cards */}
          <div className="flex w-full flex-col items-center gap-4 md:flex-row md:gap-[28px]">
            {FEATURES_DATA.slice(0, 2).map((feature) => (
              <div
                key={feature.id}
                className={`flex h-auto flex-col gap-[10px] rounded-[20px] bg-white p-5 md:h-[184px] md:p-[31px_32px] ${feature.width}`}
              >
                <div className="flex flex-col gap-5 md:gap-[30px]">
                  <p className="text-base font-semibold leading-[1.4] tracking-[-0.022em] text-[#4F4F4F] md:text-[20px]">
                    <Trans i18nKey={feature.titleKey} components={{ br: <br /> }} />
                  </p>
                  <div className="flex w-full items-center gap-[10px]">
                    <span
                      className={`text-xl font-bold leading-[1.3] tracking-[-0.022em] md:text-[28px] ${feature.badgeColor}`}
                    >
                      {feature.badge}
                    </span>
                    {feature.icon}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Second Row - 3 smaller cards */}
          <div className="flex w-full flex-col items-center gap-4 md:flex-row md:gap-[28px]">
            {FEATURES_DATA.slice(2, 5).map((feature) => (
              <div
                key={feature.id}
                className={`flex h-auto flex-col gap-[10px] rounded-[20px] bg-white p-5 md:h-[184px] md:p-[31px_32px] ${feature.width}`}
              >
                <div className="flex flex-col gap-5 md:gap-[30px]">
                  <p className="text-base font-semibold leading-[1.4] tracking-[-0.022em] text-[#4F4F4F] md:text-[20px]">
                    <Trans i18nKey={feature.titleKey} components={{ br: <br /> }} />
                  </p>
                  <div className="flex w-full items-center gap-[10px]">
                    <span
                      className={`text-xl font-bold leading-[1.3] tracking-[-0.022em] md:text-[28px] ${feature.badgeColor}`}
                    >
                      {feature.badge}
                    </span>
                    {feature.icon}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
